﻿module.exports = {
    "id": "sv",
    "label": "Svenska",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":           "Ogiltig Länk",
        "INVALID_LINK_TEXT":            "Använd avregistreringslänken i e-postmeddelandet för att avregistrera dig från våra utskickslistor.",
        "UNSUBSCRIBE_ARE_YOU_SURE":     "Är du säker på att du vill avregistrera den här e-postadressen från våra utskickslistor?",
        "UNSUBSCRIBE_CLICK_CONFIRM":    "Klicka på knappen \"Avregistrera\" nedan för att bekräfta.",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":   "Du har <b>avregistrerats</b> från våra utskickslistor.",
        "UNSUBSCRIBED_IN_ERROR":        "Om du har avregistrerat dig av misstag klickar du på länken <a href='/resubscribe' class='resubscribe'>registrera på nytt</a>.",
        "CANCELLED_STILL_SUBSCRIBED":   "<b>Avbrutet.</b> Du är fortfarande <b>registrerad</b> på våra utskickslistor.",
        "THANK_YOU_FOR_CONTINUING":     "Tack för att du fortsätter att delta i våra undersökningar.",
        "EMAIL_ALREADY_UNSUBSCRIBED":   "Den här e-postadressen är redan <b>avregistrerad</b> från våra utskickslistor.",
        "CLICK_RESUBSCRIBE_TO_REJOIN":  "Klicka på knappen \"Registrera På Nytt\" nedan om du vill vara med på på våra utskickslistor igen.",
        "YOU_HAVE_BEEN_RESUBSCRIBED":   "Du har <b>registrerats på nytt</b> på våra utskickslistor.",
        "YOU_ARE_ALREADY_SUBSCRIBED":   "Du är redan <b>registrerad</b> på våra utskickslistor.",
        "THANK_YOU_FOR_PARTICIPATING":  "Tack för att du deltar i våra undersökningar.",
        "CHECKING":                     "Kontrollerar...",
        "UNSUBSCRIBE":                  "Avregistrera",
        "RESUBSCRIBE":                  "Registrera På Nytt",
        "EMAIL":                        "E-post",
        "CANCEL":                       "Avbryt"
    }
};

